import React, { useEffect, useState } from 'react';
import { Col, Modal, Row, Tabs, Card } from 'antd';

import { Form } from 'antd';
import IUpdate from 'icons/IUpdate';
import IAdd from 'icons/IAdd';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import ButtonOperation from 'components/ButtonOperation';
import Address from 'components/address';

export type AllAddressesModalProps = {
  tpid: number;
  record?: any;
  onClose?: any;
  visible: boolean;
  updateAddress?: boolean;
  onSave: (add: any) => void;
  initadd: any;
  showAsModal?: boolean;
};

const AllAddressesModal = (props: AllAddressesModalProps) => {
  const {
    onClose,
    onSave,
    initadd,
    updateAddress = false,
    visible = false,
    record,
    showAsModal,
  } = props;
  const [form] = Form.useForm();

  const [state, setstate] = useState<any>({
    AddressElement: updateAddress ? record : initadd,
  });

  const reset = () => {
    setstate({ ...state, AddressElement: updateAddress ? record : initadd });
  };

  useEffect(() => {
    form.setFieldsValue(record ?? initadd);
  }, [form, record, initadd]);

  return (
    <Modal
      visible={visible}
      title={record ? 'Update Address' : 'Add Address'}
      width="1200px"
      style={{ top: 100 }}
      footer={null}
      destroyOnClose
      onCancel={() => {
        onClose();
        reset();
      }}
    >
      <Form
        form={form}
        onFinish={(e) => {
          e = { ...e, tpadrid: form.getFieldValue('tpadrid') };

          onSave(e);
          //   onClose();
        }}
      >
        <Tabs
          type="card"
          tabBarExtraContent={
            !showAsModal && (
              <Row gutter={16}>
                <Col span={0} />

                <Col span={10}>
                  <ButtonOperation comcode="Cancel" onClick={onClose} />
                </Col>
                <Col span={13}>
                  <ButtonOperation
                    icon={record ? <IUpdate></IUpdate> : <IAdd></IAdd>}
                    comcode={record ? 'Update' : 'Add'}
                    htmlType="submit"
                  />
                </Col>
              </Row>
            )
          }
        ></Tabs>

        <Card bordered>
          <Row gutter={16}>
            <Col xs={6}>
              <FormInput labelCol={{ span: 9 }} name="adrtype">
                <ParListSelect parcode="ADRTYPE" disabled={record} />
              </FormInput>
            </Col>
            <Col xs={12} />
            <FormInput
              col
              xs={11}
              labelCol={{ span: 5 }}
              name="tpmainadrstreet1"
            />
            <FormInput col xs={11} labelCol={{ span: 5 }} name="tpmainadrstreet2" />

            <Address
              form={form}
              paysField="tpmainadrcountry"
              regionField="tpmainadrregion"
              regionGlobalField="tpmainadrregionglobale"
              villeField="tpmainadrcity"
              codePostalField="tpmainadrzipcode"
              colU={6}
              spanZip={8}
              spanGlobalRegion={8}
              addValue={localStorage?.getItem('userrole') === 'ADMIN'}
              Colw={{ span: 7 }}
            />
          </Row>
        </Card>
      </Form>
    </Modal>
  );
};

export default AllAddressesModal;
